import { Currency } from 'dinero.js'

function normalizeLocale(locale: string): string {
  const [language = '', region = ''] = locale.split('-')
  if (language && region) {
    return `${language.toLowerCase()}-${region.toUpperCase()}`
  }
  return locale
}

function fromCents(
  cents: string,
  currency: Currency = 'EUR',
  locale = 'en',
  style: keyof Intl.NumberFormatOptionsStyleRegistry | undefined = 'currency'
): string {
  const normalizedLocale = normalizeLocale(locale)
  const value = Number(cents || '0') / 100
  return new Intl.NumberFormat(normalizedLocale, {
    style,
    currency,
  }).format(value)
}

export { fromCents }
